import ContentLoader from "react-content-loader";

const index = () => {
  return (
    <ContentLoader
      height={140}
      speed={1}
      backgroundColor={"#3b3301"}
      foregroundColor={"#141212"}
      viewBox="0 0 380 70"
    >
      <rect x="0" y="0" rx="50" ry="50" width="40" height="40" />
      <rect x="50" y="5" rx="7" ry="7" width="300" height="15" />
      <rect x="50" y="30" rx="5" ry="5" width="250" height="10" />
    </ContentLoader>
  );
};

export default index;
